import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./pages/home/home.routes').then((m) => m.routes),
  },
  {
    path: 'contratacion',
    loadChildren: () =>
      import('./pages/hiring/hiring.routes').then((m) => m.routes),
  },
  {
    path: 'pagos',
    loadChildren: () =>
      import('./pages/payments/payments.routes').then((m) => m.routes),
  },
  {
    path: 'pagar-factura',
    loadChildren: () =>
      import('./pages/billing/billing.routes').then((m) => m.routes),
  },
  {
    path: 'registro-linea',
    loadChildren: () =>
      import('./pages/line-registration/line-registration.routes').then(
        (m) => m.routes,
      ),
  },
];
